import React from 'react';
import { Link } from 'react-router-dom';
import {
    message,
    Table,
    Tabs,
    Radio,
    Button,
    Popover,
    Modal,
    Form,
    Pagination,
    Row,
    Col,
    Icon,
    Input,
    Select,
    DatePicker,
    Spin,
} from 'antd';
const FormItem = Form.Item;
const RangePicker = DatePicker.RangePicker;
const TabPane = Tabs.TabPane;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
import { onFieldsChange, getLogs } from './action';
import { connect } from 'react-redux';
import constant from './constant';
import moment from 'moment';
import ReactEcharts from 'echarts-for-react';

class ProxyExecuteData extends React.Component {
    constructor(props) {
        super(props);
        this.handlePaginationChange = this.handlePaginationChange.bind(this);
        this.handleOnFieldsChange = this.handleOnFieldsChange.bind(this);
    }

    componentDidMount() {
        this.props.getLogs(); //查询操作日志
    }

    componentWillUnmount() {
        let _serach = this.props.search;
        let _obj = {};
        Object.keys(_serach).forEach((key, index) => {
            _obj[key] = '';
        });
        this.props.onFieldsChange(Object.assign(_obj, { page: 1, pageSize: 10 }));
    }

    handleOnFieldsChange(fields) {
        let _obj = {};
        Object.keys(fields).forEach((key, index) => {
            _obj[key] = fields[key].value;
        });
        this.props.onFieldsChange(Object.assign(_obj));
    }

    handlePaginationChange(page, per_page) {
        this.props.onFieldsChange({ page: page, pageSize: per_page });
        this.props.getLogs();
        this.props.getLogsArea();

    }

    render() {
        let agantColums = [
            
            {
                title: '代理商',
                dataIndex: 'agant',
                key: 'agant',
            },
            {
                title: 'eId',
                dataIndex: 'eId',
                key: 'eId',
            },
            // {
            //     title: 'taskId',
            //     dataIndex: 'taskId',
            //     key: 'taskId',
            // },
            {
                title: '任务类型',
                dataIndex: 'taskType',
                key: 'taskType',
            },
            {
                title: '日期',
                dataIndex: 'tm',
                key: 'tm',
            },
            {
                title: '成功数',
                dataIndex: 'successCount',
                key: 'successCount',
            },
            {
                title: '失败数',
                dataIndex: 'errorCount',
                key: 'errorCount',
            },
        ];
        let areaColums = [
            
            {
                title: '地区',
                dataIndex: 'area',
                key: 'area',
            },
            {
                title: 'eId',
                dataIndex: 'eId',
                key: 'eId',
            },
            // {
            //     title: 'taskId',
            //     dataIndex: 'taskId',
            //     key: 'taskId',
            // },
            {
                title: '任务类型',
                dataIndex: 'taskType',
                key: 'taskType',
            },
            {
                title: '日期',
                dataIndex: 'tm',
                key: 'tm',
            },
            {
                title: '成功数',
                dataIndex: 'successCount',
                key: 'successCount',
            },
            {
                title: '失败数',
                dataIndex: 'errorCount',
                key: 'errorCount',
            },
        ];
        const { logs,logsArea, loading, search } = this.props;
        const { total } = search;
        return (
            <div>
                <SearchForm {...this.props} handleOnFieldsChange={this.handleOnFieldsChange} />
                <Spin spinning={loading} tip="加载中">
                    {/* <Table columns={columns} dataSource={logs} pagination={false} bordered /> */}
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="代理" key="1">
                            <Table
                                columns={agantColums}
                                dataSource={logs}
                                pagination={false}
                                defaultExpandAllRows={false}
                            />
                        </TabPane>
                        <TabPane tab="地区" key="2">
                            <Table
                                columns={areaColums}
                                dataSource={logsArea}
                                pagination={false}
                                defaultExpandAllRows={false}
                            />
                        </TabPane>
                       
                    </Tabs>
                    {/* <Pagination
                        showQuickJumper
                        showSizeChanger
                        total={total}
                        className="ant-table-pagination"
                        onChange={this.handlePaginationChange}
                        onShowSizeChange={this.handlePaginationChange}
                    /> */}
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.proxyExecuteData.loading.loading,
    search: state.proxyExecuteData.search,
    logs: state.proxyExecuteData.logs,
    logsArea: state.proxyExecuteData.logsArea,

});

const mapDispatchToProps = dispatch => ({
    onFieldsChange: search => dispatch(onFieldsChange(search)),
    getLogs: () => dispatch(getLogs()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProxyExecuteData);

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.handleReset = this.handleReset.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    handleReset() {
        this.props.form.resetFields();
    }

    //查询
    handleSearch(e) {
        e.preventDefault();
        this.props.getLogs();
    }

    render() {
        const { areas, agents } = this.props;
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>代理执行数据统计</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                <Row style={{ marginBottom: '10px' }}>
                        <Col span={5} >
                            <FormItem label="taskId" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('taskId')(<Input style={{ width: 150 }} placeholder="" />)}
                            </FormItem>
                        </Col>
                        <Col span={5} >
                            <FormItem label="eId" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('eId')(<Input style={{ width: 150 }} placeholder="" />)}
                            </FormItem>
                        </Col>
                        <Col span={5}>
                            <FormItem label="任务类型" labelCol={{ span: 7 }} wrapperCol={{ span: 16 }}>
                                {getFieldDecorator('taskType')(
                                <Select allowClear style={{ width: 150 }} placeholder="" >
                                    <Option value="EV">曝光</Option>
                                    <Option value="CLICK">点击</Option>
                                    <Option value='APPLAUNCH'>APP拉起</Option>
                                    <Option value='COMBINE_EV_CLICK'>合并</Option>
                                    <Option value='APP_RETAIN'>注册留存</Option>
                                    <Option value='RE'>注册</Option>
                                </Select>,
                            )}
                            </FormItem>
                            
                        </Col>
                        <Col span={5}>
                         <FormItem label="时间" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('tm', {
                                    initialValue: '',
                                })(
                                    <DatePicker
                                        style={{ width: 200 }}
                                        format="YYYY-MM-DD"
                                    />,
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>
                                重置
                            </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                            <Button type="primary" htmlType="submit">
                                搜索
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}
const SearchForm = Form.create({
    onFieldsChange(props, fields) {
        props.handleOnFieldsChange(fields);
    },
})(Search);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/proxyExecuteData/index.js